import { toast, Bounce } from 'react-toastify';

export const APP_ENV = process.env.REACT_APP_ENV ?? 'dev';

/**
 * ***************************
 * ROLES
 * ***************************
 */
export const ROLES = {
  ACCOUNTANT: 'accountant',
  CMS: 'cms',
  BOOKING: 'booking',
  USER_MANAGER: 'user-manager',
  REPORT: 'report',
  MARKETING: 'marketing',
  TOUR_LEADER: 'tourleader',
  BOOKING_MANAGER: 'booking-manager',
  AGENCY: 'agency',
};
export const roleChoices = [
  { label: 'Booking', value: ROLES.BOOKING },
  { label: 'Cms', value: ROLES.CMS },
  { label: 'Marketing', value: ROLES.MARKETING },
  { label: 'Report', value: ROLES.REPORT },
  { label: 'User manager', value: ROLES.USER_MANAGER },
  { label: 'Tour leader', value: ROLES.TOUR_LEADER },
  { label: 'Booking manager', value: ROLES.BOOKING_MANAGER },
  { label: 'Accountant', value: ROLES.ACCOUNTANT },
];

/**
 * ***************************
 * PATHS
 * ***************************
 */
export const ADMIN_PATH = 'admin';
export const USERS_PATH = `${ADMIN_PATH}/users`;
export const BOOKING_PATH = 'booking';
export const CMS_PATH = 'cms';
export const LOGS_PATH = 'logs';
export const MARKETING_PATH = 'marketing';
export const REPORT_PATH = 'report';
export const AGENCY_PATH = 'agenzia';

/**
 * ***************************
 * SITES NAMES, Must improve
 * ***************************
 */
export const SITES_NAME = {
  speedvacanze: 'SpeedVacanze',
  velaventure: 'VelaVenture',
  adoraventure: 'AdoraVenture',
};
export const SITE_CHOICES = Object.keys(SITES_NAME).map((site) => ({
  value: site,
  label: SITES_NAME[site],
}));

/**
 * ***************************
 * USER Tabs
 * ***************************
 */
const makeTabConfig = (label) => ({ label, path: label.toLowerCase() });

export const USER_TABS = ['User', 'Marketing', 'TourLeader', 'Password'].map(
  makeTabConfig,
);

export const AGENCY_TABS = ['Agency', 'Password'].map(
  makeTabConfig,
);

export const MARKETING_ROLES = [
  { label: 'Editor', value: 'editor' },
  { label: 'Manager', value: 'manager' },
  { label: 'Advertiser', value: 'advertiser' },
];

export const TOASTR_OPTIONS = {
  position: toast.POSITION.BOTTOM_RIGHT,
  transition: Bounce,
  theme: 'colored',
};
